import { BrowserRouter as Router } from "react-router-dom";
import Nav from "./sections/Nav";
import Footer from "./sections/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { AppRoutes } from "./routes/AppRoutes";

// Fonts
import "@fontsource/geist-sans/100.css";
import "@fontsource/geist-sans/200.css";
import "@fontsource/geist-sans/300.css";
import "@fontsource/geist-sans/400.css";
import "@fontsource/geist-sans/500.css";
import "@fontsource/geist-sans/600.css";
import "@fontsource/geist-sans/700.css";
import "@fontsource/geist-sans/800.css";
import "@fontsource/geist-sans/900.css";
import "@fontsource/bebas-neue";

// Global Styles
import "./App.css";
import "./styles/landing.css";
import "./styles/solutions.css";
import "./styles/industries.css";
import "./styles/nav.css";
import "./styles/cms.css";


// We create app content to define componenets required on every page allows app routes to stay "DRY"
function AppContent() {
  return (
    <>
      <Nav />
        <ScrollToTop>
          <AppRoutes />
        </ScrollToTop>
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;